import {
  getDeliveryShopId,
  makeIntervalISODate,
} from '@epicuro-next/utilities';

import {
  BulkTypeDeliveryPeriod,
  BusinessState,
  DeliveryPeriodsByPeriodType,
  DeliveryPeriodType,
} from '../models';

export function getSelectedDeliveryPeriod(state: BusinessState): string {
  const activeShop = state.activeDeliveryShop;
  const activeShopKey = getDeliveryShopId(activeShop);

  const deliveryShopPeriods = state.deliveryPeriods[activeShopKey] ?? {};
  const currentDeliveryPeriodType =
    deliveryShopPeriods.currentDeliveryPeriodType;

  return getShopSelectedDeliveryPeriod(
    deliveryShopPeriods,
    currentDeliveryPeriodType,
  );
}

export function getShopSelectedDeliveryPeriod(
  currentShopDeliveryPeriods: DeliveryPeriodsByPeriodType,
  currentShopCurrentDeliveryPeriodType: DeliveryPeriodType = DeliveryPeriodType.Now,
): string {
  if (currentShopCurrentDeliveryPeriodType === DeliveryPeriodType.Future) {
    return currentShopDeliveryPeriods[currentShopCurrentDeliveryPeriodType]
      ?.selectedDeliveryPeriod as string;
  }

  if (currentShopCurrentDeliveryPeriodType === DeliveryPeriodType.Bulk) {
    const { from, to } =
      (currentShopDeliveryPeriods[currentShopCurrentDeliveryPeriodType]
        ?.selectedDeliveryPeriod as BulkTypeDeliveryPeriod) ?? {};
    return from ? makeIntervalISODate(from, to) : '';
  }

  return DeliveryPeriodType.Now;
}
